import type { FC } from 'react';
import { AcquisitionSection } from '../acquisition-page/section';
import { DemographicSection } from '../demographic-page/section';
import { EngagementSection } from '../engagement-page/section';
import { RetentionSection } from '../retention-page/section';
import { OverviewSection } from './section';
import type { PageCoupon } from './use-page-coupon';
import type { ResolvedPageFilter } from './use-page-filter';

export type AnalyticsTabKey =
    | 'overview'
    | 'acquisition'
    | 'engagement'
    | 'retention'
    | 'demographic';

export interface AnalyticsSectionProps {
    filter: ResolvedPageFilter;
    pageCoupon: PageCoupon;
    onSelectTab: (key: AnalyticsTabKey) => void;
}

export interface AnalyticsTab {
    key: AnalyticsTabKey;
    label: string;
    Section: FC<AnalyticsSectionProps>;
}

export const ANALYTICS_TABS: readonly AnalyticsTab[] = [
    { key: 'overview', label: 'Overview', Section: OverviewSection },
    {
        key: 'acquisition',
        label: 'Acquisition & Activation',
        Section: AcquisitionSection,
    },
    {
        key: 'engagement',
        label: 'Engagement and Usage',
        Section: EngagementSection,
    },
    {
        key: 'retention',
        label: 'Retention & Health',
        Section: RetentionSection,
    },
    {
        key: 'demographic',
        label: 'Regional & demographic',
        Section: DemographicSection,
    },
];

export const ANALYTICS_TAB_KEYS = ANALYTICS_TABS.map((tab) => tab.key);

export const DEFAULT_ANALYTICS_TAB: AnalyticsTabKey = 'overview';
